import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            影视热榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            根据播放量、搜索热度与用户讨论综合排序，每周更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item, idx) => (
            <a
              key={item.id}
              href="#cards"
              className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-200/60 transition-colors cursor-pointer group border-b border-background-200/50 last:border-b-0"
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center font-heading font-bold text-lg flex-shrink-0 ${
                  idx === 0
                    ? 'bg-accent-500 text-background-50'
                    : idx === 1
                    ? 'bg-secondary-400 text-background-50'
                    : idx === 2
                    ? 'bg-primary-400 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {idx + 1}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </span>
                  <span className="px-1.5 py-0.5 text-[10px] font-medium text-foreground-500 bg-background-200 rounded whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <i
                  className={`text-sm ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : item.trend === 'down'
                      ? 'ri-arrow-down-line text-foreground-400'
                      : 'ri-subtract-line text-foreground-400'
                  }`}
                ></i>
                <span className="text-sm font-semibold text-accent-500">{item.hot}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}